import type { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/timeSettings${`?type=${OrganizationNotificationType}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/timeSettings`;

export const URL = (type: OrganizationNotificationType): RouteDefinition => `${baseRoute}/timeSettings?type=${type}`;
